import { useStore } from 'zustand';
import { useMediaClient } from './useMediaClient';
var createBoundedUseStore = function createBoundedUseStore(store) {
  return function (selector, equals) {
    return useStore(store, selector, equals);
  };
};
export function useMediaStore(selector, equals) {
  var mediaClient = useMediaClient();
  var store = mediaClient.__DO_NOT_USE__getMediaStore();
  var useBoundStore = createBoundedUseStore(store);
  return useBoundStore(selector, equals);
}